<!-- Page intro -->
<section class="recv-intro" id="receivers-overview">
  <div class="recv-container">
    <p class="recv-kicker">Hardware</p>
    <h1 class="recv-page-title">GNSS Hardware</h1>
    <p class="recv-page-subtitle">
      Professional hardware for centimeter-level RTK, satellite PPP, heading, and reliable field positioning.
    </p>
    <div class="recv-jump">
      <button type="button" class="recv-jump-chip" (click)="scrollTo('receiver-x8-m1')">X8-M1</button>
      <button type="button" class="recv-jump-chip" (click)="scrollTo('receiver-rtu609bt')">RTU609BT</button>
      <button type="button" class="recv-jump-chip" (click)="scrollTo('receiver-rtu608bt')">RTU608BT</button>
      <button type="button" class="recv-jump-chip" (click)="scrollTo('receiver-y55g')">Y55G</button>
      <button type="button" class="recv-jump-chip" (click)="scrollTo('receiver-gc-9140kb')">GC-9140KB</button>
    </div>
  </div>
</section>

<!-- X8-M1 -->
<section class="recv-product" id="receiver-x8-m1">
  <div class="recv-container">
    <div class="recv-split">
      <div class="recv-copy">
        <p class="recv-product-kicker">Portable RTK</p>
        <h2 class="recv-product-title">GeoAstra X8-M1 RTK GNSS Receiver</h2>
        <p class="recv-product-lead">
          Ultra-portable tri-band RTK receiver for centimeter-level positioning in the field.
        </p>
        <ul class="recv-specs">
          <li>Up to ~1 cm RTK accuracy</li>
          <li>Full constellation, tri-band support</li>
          <li>Bluetooth 5.1 + 4G LTE options</li>
          <li>IP67, ~20-hour battery, only ~104 g</li>
        </ul>
        <div class="recv-actions">
          <button type="button" class="btn btn-primary px-4" (click)="openExternal(buyUrls.x8m1)">Buy</button>
        </div>
      </div>
      <div class="recv-media">
        <img
          src="assets/images/landing/GeoAstra_X8-M1_clean.png"
          class="recv-product-img lnc-zoom-img"
          alt="GeoAstra X8-M1 RTK GNSS Receiver"
          loading="eager"
          (click)="openLightbox('assets/images/landing/GeoAstra_X8-M1_clean.png','GeoAstra X8-M1 RTK GNSS Receiver')"
        >
      </div>
    </div>
  </div>
</section>

<!-- RTU609BT -->
<section class="recv-product recv-product--alt" id="receiver-rtu609bt">
  <div class="recv-container">
    <div class="recv-split recv-split--reverse">
      <div class="recv-copy">
        <p class="recv-product-kicker">Positioning + Heading</p>
        <h2 class="recv-product-title">GeoAstra RTU609BT Dual-RTK Heading GNSS Receiver</h2>
        <p class="recv-product-lead">
          Dual-antenna, dual-RTK engine for high-precision position and heading.
        </p>
        <ul class="recv-specs">
          <li>Up to ~0.8 cm position accuracy</li>
          <li>Heading accuracy down to ~0.2°</li>
          <li>L1 / L2 / L5 tri-band</li>
          <li>Bluetooth + USB dual interfaces</li>
        </ul>
        <div class="recv-actions">
          <button type="button" class="btn btn-primary px-4" (click)="openExternal(buyUrls.rtu609bt)">Buy</button>
        </div>
      </div>
      <div class="recv-media">
        <img
          src="assets/images/landing/GeoAstra_RTU609BT_clean.png"
          class="recv-product-img lnc-zoom-img"
          alt="GeoAstra RTU609BT Dual-RTK Heading GNSS Receiver"
          loading="lazy"
          (click)="openLightbox('assets/images/landing/GeoAstra_RTU609BT_clean.png','GeoAstra RTU609BT Dual-RTK Heading GNSS Receiver')"
        >
      </div>
    </div>
  </div>
</section>

<!-- RTU608BT -->
<section class="recv-product" id="receiver-rtu608bt">
  <div class="recv-container">
    <div class="recv-split">
      <div class="recv-copy">
        <p class="recv-product-kicker">Industrial Grade</p>
        <h2 class="recv-product-title">GeoAstra RTU608BT RTK GNSS Receiver</h2>
        <p class="recv-product-lead">
          Rugged USB / Bluetooth RTK receiver built for industrial environments.
        </p>
        <ul class="recv-specs">
          <li>Multi-band RTK up to ~1.4 cm</li>
          <li>~30 cm standalone accuracy</li>
          <li>IP67 waterproof housing</li>
          <li>Operating range −40°C to +85°C</li>
        </ul>
        <div class="recv-actions">
          <button type="button" class="btn btn-primary px-4" (click)="openExternal(buyUrls.rtu608bt)">Buy</button>
        </div>
      </div>
      <div class="recv-media">
        <img
          src="assets/images/landing/GeoAstra_RTU608BT_clean.jpg"
          class="recv-product-img lnc-zoom-img"
          alt="GeoAstra RTU608BT RTK GNSS Receiver"
          loading="lazy"
          (click)="openLightbox('assets/images/landing/GeoAstra_RTU608BT_clean.jpg','GeoAstra RTU608BT RTK GNSS Receiver')"
        >
      </div>
    </div>
  </div>
</section>

<!-- Y55G -->
<section class="recv-product recv-product--alt" id="receiver-y55g">
  <div class="recv-container">
    <div class="recv-split recv-split--reverse">
      <div class="recv-copy">
        <p class="recv-product-kicker">RTK + Satellite PPP</p>
        <h2 class="recv-product-title">GeoAstra Y55G RTK/PPP GNSS Android Device</h2>
        <p class="recv-product-lead">
          Rugged all-in-one Android field device with centimeter-level RTK and satellite-delivered PPP positioning.
        </p>
        <ul class="recv-specs">
          <li>Up to 1 cm + 1 ppm RTK accuracy</li>
          <li>~20 cm PPP with Galileo HAS and BeiDou B2b</li>
          <li>Android 14 with Google Play and full-band GNSS</li>
          <li>IP68 housing and 18–22 hour battery life</li>
        </ul>
        <div class="recv-actions">
          <button type="button" class="btn btn-primary px-4" (click)="openExternal(buyUrls.y55g)">Buy</button>
        </div>
      </div>
      <div class="recv-media">
        <img
          src="assets/images/landing/GeoAstra_Y55G.png"
          class="recv-product-img lnc-zoom-img"
          alt="GeoAstra Y55G RTK/PPP GNSS Android Device"
          loading="lazy"
          (click)="openLightbox('assets/images/landing/GeoAstra_Y55G.png','GeoAstra Y55G RTK/PPP GNSS Android Device')"
        >
      </div>
    </div>
  </div>
</section>

<!-- GC-9140KB -->
<section class="recv-product" id="receiver-gc-9140kb">
  <div class="recv-container">
    <div class="recv-split">
      <div class="recv-copy">
        <p class="recv-product-kicker">Industrial USB-C GNSS</p>
        <h2 class="recv-product-title">GeoAstra GC-9140KB USB-C GNSS Receiver</h2>
        <p class="recv-product-lead">
          Compact, plug-and-play receiver for computers, Android devices, robotics, and embedded field systems.
        </p>
        <ul class="recv-specs">
          <li>u-blox M9140-KB with six-constellation support</li>
          <li>Configurable update rate up to 25 Hz</li>
          <li>1.5 m horizontal accuracy with SBAS</li>
          <li>IP67 magnetic housing rated from −40°C to +85°C</li>
        </ul>
        <div class="recv-actions">
          <button type="button" class="btn btn-primary px-4" (click)="openExternal(buyUrls.gc9140kb)">Buy</button>
        </div>
      </div>
      <div class="recv-media">
        <img
          src="assets/images/landing/GeoAstra_GC-9140KB.png"
          class="recv-product-img lnc-zoom-img"
          alt="GeoAstra GC-9140KB USB-C GNSS Receiver"
          loading="lazy"
          (click)="openLightbox('assets/images/landing/GeoAstra_GC-9140KB.png','GeoAstra GC-9140KB USB-C GNSS Receiver')"
        >
      </div>
    </div>
  </div>
</section>

<!-- Lightbox overlay -->
<div *ngIf="lightboxOpen" class="lightbox-backdrop" (click)="closeLightbox()">
  <div class="lightbox-content" (click)="$event.stopPropagation()">
    <button type="button" class="btn-close lightbox-close" aria-label="Close" (click)="closeLightbox()"></button>
    <img [src]="lightboxSrc" [alt]="lightboxAlt" class="img-fluid w-100" />
  </div>
</div>
